import { useNavigate } from 'react-router';
import { useMutation } from '@tanstack/react-query';
import * as R from 'Router/routes';
import { fetchData } from 'utils';
import { useStore } from 'hooks/useStore';
import useSmartlook from 'hooks/useSmartlook';

export default function useBankIDSessionsRejectMutation() {
  const navigate = useNavigate();
  const { error } = useSmartlook();
  const [storeBankId, setStoreBankId] = useStore((store) => store.bankId);
  return useMutation<void, unknown, string>({
    mutationFn: async (uuid: string) => {
      try {
        return await fetchData(`/proxy/bankid/sessions/${uuid}/reject`, {
          method: 'POST',
        });
      } catch (e) {
        error(
          '[useBankIDSessionsRejectMutation][POST /proxy/bankid/sessions/{uuid}/reject]',
          e,
        );
        setStoreBankId({
          bankId: {
            ...storeBankId,
            error: true,
          },
        });
        navigate(R.BANK_ID_ERROR);
        return undefined;
      }
    },
  });
}
